import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { formatPrice, treatmentPath } from "@/lib/format";
import { SmartImage } from "./Ui";

const FALLBACKS = ["/img/viso.webp", "/img/precisione.webp", "/img/consulenza.webp", "/img/centro-7284.webp"];

export function TreatmentCard({ t, index = 0 }) {
  return (
    <Link to={treatmentPath(t)} className="card-soft group flex flex-col p-7" data-testid={`treatment-card-${t.slug}`}>
      <p className="eyebrow">{t.category_name || "Trattamento"}</p>
      <h3 className="mt-3 text-2xl sm:text-3xl">{t.name}</h3>
      <p className="mt-3 flex-1 text-sm leading-relaxed text-[var(--muted-ink)]">{t.short_description}</p>
      <div className="mt-6 flex items-center justify-between border-t border-[var(--line)] pt-4 text-sm">
        <span className="font-medium text-[var(--petrol)]" data-testid={`treatment-card-price-${t.slug}`}>{formatPrice(t.price_type, t.price_cents)}</span>
        <span className="flex items-center gap-1 text-[var(--muted-ink)]">{t.duration_min} min <ArrowUpRight size={16} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" /></span>
      </div>
    </Link>
  );
}

export function CategoryCard({ c, index = 0, tall = false }) {
  return (
    <Link to={`/trattamenti/${c.slug}`} className="img-zoom group relative block overflow-hidden rounded-2xl" data-testid={`category-card-${c.slug}`}>
      <SmartImage mediaId={c.image_media_id} fallback={FALLBACKS[index % 4]} alt={c.image_alt || ""} className={`w-full object-cover ${tall ? "aspect-[3/4]" : "aspect-[4/3]"}`} size="md" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/10 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 p-6 text-[var(--ivory)]">
        <h3 className="text-3xl">{c.name}</h3>
        <p className="mt-2 line-clamp-2 text-sm text-ivory/85">{c.intro}</p>
      </div>
    </Link>
  );
}
